/* Stroomkaart - translations: public map page
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Kaart (publieke kaart-pagina) ----- */
  map: {
    title: 'Kaart - Stroomkaart',
    page_title: 'Beschikbare stroompunten',
    page_sub:   'Filter op locatie, status en type. Klik een punt voor details en dien direct een aanvraag in.',
    sidebar_title: 'Stroompunten',
    points_found: 'punten gevonden',
    toggle_sidebar: 'Zijbalk in-/uitklappen',
    charger_zoom_hint: 'Zoom in op de straat waar u een laadpaal wilt gebruiken om individuele laadpalen te zien.',
    search_placeholder: 'Zoek op stad, adres of stroompuntnaam',
    draw_first_vertex:  'Klik om je eerste hoekpunt te plaatsen',
    finish_area:        'Klaar - gebied versturen',
    connector_explainer: 'wie voert de fysieke aansluiting uit? Beiden krijgen een bevestigingsmail.',
    filter_status:      'Status',
    filter_type:        'Type aansluiting',
    filter_all:         'Alle',
    filter_power_station: 'Stroompunt',
    filter_indirect_station: 'Indirect stroompunt',
    filter_ac:           'AC laadpaal',
    filter_dc:           'DC snellader',
    filter_water:        'Watertappunt',
    no_matches:         'Geen stroompunten gevonden. Pas je filters aan.',
    search: {
      points:    'Stroompunten',
      addresses: 'Adressen',
    },
    // Legacy keys retained for any template that still references them.
    filter_construction: 'Bouw',
    filter_charging:     'Laadpaal',
    filter_shore:        'Walstroom',
    filter_event:        'Evenement',
    filter_indirect:     'Indirect',
    status: {
      available:      'Beschikbaar',
      maintenance:    'Onderhoud',
      out_of_service: 'Buiten gebruik',
      indirect: 'Indirect',
      occupied: 'Bezet',
      soon: 'Binnenkort',
    },
    legend: {
      available:      'Beschikbaar',
      maintenance:    'Onderhoud',
      out_of_service: 'Buiten gebruik',
      indirect: 'Indirect',
      occupied: 'Bezet',
      soon: 'Binnenkort',
    },
    detail: {
      capacity:    'Vermogen',
      connection:  'Aansluiting',
      type:        'Type',
      tariff:      'Tarief',
      always:      'Beschikbaarheid',
      close:       'Sluiten',
      btn_request: 'Aanvragen',
      btn_request_indirect: 'Voorbereiding aanvragen',
      btn_add_to_request: '+ Toevoegen aan reservering',
      btn_route:   'Route',
      btn_usage:   'Gebruikshistorie (beheer)',
      doorlooptijd:'Doorlooptijd: circa',
      werkdagen:   'werkdagen',
      operator:        'Aanbieder',
      charging_points: 'Laadplekken',
      connector:       'Aansluiting',
    },
    results_label: 'resultaten',
    results_empty: 'Geen stroompunten gevonden. Pas je filters aan.',
    area_cta: {
      title: 'Niet gevonden wat je zoekt?',
      body:  'Teken een gebied op de kaart en wij gaan voor je op zoek naar geschikte stroompunten - ook punten die nog niet zijn aangemeld.',
      btn:   'Teken een gebied →',
      btn_delete: 'Verwijder gebied',
    },
    draw: {
      toast_main:  'Teken het gebied waar je stroom nodig hebt',
      toast_first: 'Klik op de kaart om je eerste hoekpunt te plaatsen',
      toast_hint:  'Tip: klik op het startpunt om te sluiten · Backspace = ongedaan · Esc = annuleren',
      btn_cancel:  'Annuleren',
      btn_undo:    'Ongedaan maken',
      btn_reset:   'Opnieuw',
      btn_finish:  'Klaar - gebied versturen',
    },
    area_modal: {
      title:           'Geen punt gevonden - vraag een nieuw gebied aan',
      sub:             'We zoeken voor je naar een geschikt stroompunt binnen jouw ingetekende gebied. Je hoort binnen 2 werkdagen van onze projectcoördinator.',
      area_title:      'Jouw ingetekende gebied',
      hoekpunten:      'hoekpunten',
      ongeveer:        'circa',
      label_project:   'Projectnaam',
      label_org:       'Organisatie',
      label_capacity:  'Max. stroom (A)',
      label_connector: 'Type aansluiting',
      connector_ph:    'Kies een type…',
      connector_unknown: 'Onbekend',
      label_period:    'Gewenste periode',
      label_name:      'Contactpersoon',
      label_email:     'E-mailadres',
      label_phone:     'Telefoon',
      label_connector_email: 'E-mail aansluiter',
      label_note:      'Toelichting (optioneel)',
      placeholder_project: 'Bijv. Nieuwbouw Spoorzone',
      placeholder_period:  'Bijv. juni 2026 – feb 2027',
      placeholder_note:    'Bijzonderheden over het project, locatie of aansluitwensen…',
      select_choose:       'Kies…',
      capacity_unknown:    'Weet ik nog niet',
      btn_same_as_org: 'Zelfde als organisatie',
      btn_cancel:      'Annuleren',
      btn_submit:      'Aanvraag versturen',
      success_title:   'Aanvraag ontvangen',
      success_body:    'Bedankt - we hebben je aanvraag ontvangen. Je hoort binnen 2 werkdagen van onze projectcoördinator. Een bevestigingsmail is naar je gestuurd.',
      success_close:   'Sluiten',
    },
    // Booking modal - keys + values mirror designer's translations.js (map.book.*).
    // Extras (submitting, submit_failed, whats_next, aansluiter_email_ph) live alongside
    // because designer's HTML doesn't expose them but ours does.
    book: {
      title: 'Reserveer een stroompunt',
      close: 'Sluiten',
      start: 'Startdatum',
      end: 'Einddatum',
      org_section: 'Organisatie',
      org: 'Organisatie',
      project: 'Projectnaam (optioneel)',
      project_ph: 'Bijv. Renovatie Kattenburgerplein',
      email: 'Contact e-mailadres',
      phone: 'Telefoonnummer',
      tech_section: 'Technisch contactpersoon',
      tech_name: 'Naam',
      tech_role: 'Functie (optioneel)',
      tech_role_ph: 'Bijv. Werkvoorbereider',
      aansluiter_info: '<strong>Aansluiter</strong> - wie voert de fysieke aansluiting uit? Beiden krijgen een bevestigingsmail.',
      aansluiter_copy: 'Zelfde als organisatie',
      aansluiter_name: 'Naam aansluiter',
      aansluiter_email: 'E-mail aansluiter',
      aansluiter_email_ph: 'aansluiter@bedrijf.nl',
      aansluiter_phone: 'Telefoon aansluiter (optioneel)',
      aansluiter_company: 'Bedrijf aansluiter (optioneel)',
      capacity: 'Max. stroom (A)',
      capacity_ph: 'Wordt overgenomen van het punt indien leeg',
      connector: 'Type aansluiting',
      connector_ph: 'Kies een type…',
      connector_unknown: 'Onbekend',
      connection: 'Aansluiting (optioneel)',
      connection_ph: 'Bijv. CEE 3x63A',
      cancel: 'Annuleren',
      submit: 'Verzend aanvraag →',
      submitting: 'Verzenden…',
      submit_failed: 'Versturen mislukt.',
      stations_section: 'Gekozen stations',
      add_station: '+ Voeg ander station toe',
      picking_banner: 'Klik een station op de kaart om toe te voegen aan je reservering.',
      picking_cancel: 'Annuleer',
      success_title: 'Bedankt voor uw aanvraag!',
      success_body: 'U ontvangt een bevestiging voor het gebruik met daarin uitleg over de vervolgstappen.',
      done: 'Sluiten',
      whats_next: 'Wat gebeurt er nu?',
      // Charging-station-only questions (shown when the picked point is a charging station).
      charging_section: 'Aanvullende gegevens laadstation',
      charging_card_q: 'Ik wil ook een bouwstroom-laadpas aanvragen',
      adapter_q: 'Ik heb een adapter nodig om aan te sluiten op het laadstation',
      adapter_info: 'Meer informatie over de adapter',
      adapter_doc_url: '/assets/flyers/adapter-brochure-nl.pdf',
      fenced_q: 'Het laadstation staat binnen de hekken en is afgesloten voor reguliere elektrische voertuigen',
      yes: 'Ja',
      no: 'Nee',
      // Billing / invoicing block (optional, shown for every request).
      finance_section: 'Facturatie (optioneel)',
      finance_info: 'Factuurgegevens voor deze aanvraag - laat leeg als deze gelijk zijn aan de organisatie.',
      finance_copy: 'Zelfde als organisatie',
      billing_name: 'Factuurnaam',
      billing_email: 'Factuur e-mailadres',
      billing_address: 'Straat en huisnummer',
      billing_postcode: 'Postcode',
      billing_city: 'Plaats',
      billing_vat: 'Btw-/KVK-nummer',
      billing_reference: 'Referentie / inkoopordernummer',
    },
    polygon: {
      first_vertex:       'Klik op de kaart om je eerste hoekpunt te plaatsen.',
      more_needed:        '{count} van min. 3 hoekpunten - plaats er nog {remaining}.',
      ready_to_close:     '{count} hoekpunten - klik het startpunt of "Klaar" om te sluiten.',
      self_intersect:     'Let op: het ingetekende gebied kruist zichzelf. Verzenden kan, maar de operator vraagt mogelijk om verduidelijking.',
      pick_valid_dates:   'Kies een geldige start- en einddatum.',
      end_after_start:    'Startdatum moet op of voor de einddatum liggen.',
      request_submitted:  'Aanvraag verstuurd: {id}',
      check_form:         'Controleer het formulier en probeer opnieuw.',
      submit_failed:      'Versturen mislukt.',
      submitting:         'Versturen…',
    },
  },
};

export const en = {
  map: {
    title: 'Map - Stroomkaart',
    page_title: 'Available power points',
    page_sub:   'Filter by location, status and type. Click a point for details and submit a request directly.',
    sidebar_title: 'Power points',
    points_found: 'points found',
    toggle_sidebar: 'Collapse / expand sidebar',
    charger_zoom_hint: 'In order to see individual charging stations, zoom in to the street where you would like to use one.',
    search_placeholder: 'Search by city, address or power point name',
    draw_first_vertex:  'Click to place your first vertex',
    finish_area:        'Done - submit area',
    connector_explainer: 'who performs the physical connection? Both receive a confirmation email.',
    filter_status:      'Status',
    filter_type:        'Connection type',
    filter_all:         'All',
    filter_power_station: 'Power station',
    filter_indirect_station: 'Indirect station',
    filter_ac:           'AC charger',
    filter_dc:           'DC fast charger',
    filter_water:        'Water point',
    no_matches:         'No matches. Adjust your filters.',
    search: {
      points:    'Power points',
      addresses: 'Addresses',
    },
    // Legacy keys retained for any template that still references them.
    filter_construction: 'Construction',
    filter_charging:     'EV charger',
    filter_shore:        'Shore power',
    filter_event:        'Event',
    filter_indirect:     'Indirect',
    status: {
      available:      'Available',
      maintenance:    'Maintenance',
      out_of_service: 'Out of service',
      indirect: 'Indirect',
      occupied: 'Occupied',
      soon: 'Soon',
    },
    legend: {
      available:      'Available',
      maintenance:    'Maintenance',
      out_of_service: 'Out of service',
      indirect: 'Indirect',
      occupied: 'Occupied',
      soon: 'Soon',
    },
    detail: {
      capacity:    'Capacity',
      connection:  'Connection',
      type:        'Type',
      tariff:      'Tariff',
      always:      'Availability',
      close:       'Close',
      btn_request: 'Request',
      btn_request_indirect: 'Request preparation',
      btn_add_to_request: '+ Add to reservation',
      btn_route:   'Route',
      btn_usage:   'Usage history (admin)',
      doorlooptijd:'Lead time: approx.',
      werkdagen:   'business days',
      operator:        'Operator',
      charging_points: 'Charging points',
      connector:       'Connector',
    },
    results_label: 'results',
    results_empty: 'No power points found. Adjust your filters.',
    area_cta: {
      title: 'Not finding what you need?',
      body:  "Draw an area on the map and we will look for suitable power points for you - including points not yet registered.",
      btn:   'Draw an area →',
      btn_delete: 'Delete area',
    },
    draw: {
      toast_main:  'Draw the area where you need power',
      toast_first: 'Click on the map to place your first vertex',
      toast_hint:  'Tip: click the start point to close · Backspace = undo · Esc = cancel',
      btn_cancel:  'Cancel',
      btn_undo:    'Undo',
      btn_reset:   'Reset',
      btn_finish:  'Done - submit area',
    },
    area_modal: {
      title:           'No point found - request a new area',
      sub:             "We will look for a suitable power point within your drawn area. You will hear from our project coordinator within 2 business days.",
      area_title:      'Your drawn area',
      hoekpunten:      'vertices',
      ongeveer:        'approx.',
      label_project:   'Project name',
      label_org:       'Organization',
      label_capacity:  'Max. current (A)',
      label_connector: 'Connection type',
      connector_ph:    'Choose a type…',
      connector_unknown: 'Unknown',
      label_period:    'Desired period',
      label_name:      'Contact person',
      label_email:     'Email address',
      label_phone:     'Phone',
      label_connector_email: 'Connector email',
      label_note:      'Notes (optional)',
      placeholder_project: 'e.g. Spoorzone development',
      placeholder_period:  'e.g. June 2026 – Feb 2027',
      placeholder_note:    'Anything specific about the project, location or connection requirements…',
      select_choose:       'Choose…',
      capacity_unknown:    "I don't know yet",
      btn_same_as_org: 'Same as organisation',
      btn_cancel:      'Cancel',
      btn_submit:      'Submit request',
      success_title:   'Request received',
      success_body:    "Thank you - we have received your request. You will hear from our project coordinator within 2 business days. A confirmation email has been sent to you.",
      success_close:   'Close',
    },
    book: {
      title: 'Reserve a power point',
      close: 'Close',
      start: 'Start date',
      end: 'End date',
      org_section: 'Organisation',
      org: 'Organisation',
      project: 'Project name (optional)',
      project_ph: 'E.g. Renovation Kattenburgerplein',
      email: 'Contact email',
      phone: 'Phone number',
      tech_section: 'Technical contact',
      tech_name: 'Name',
      tech_role: 'Role (optional)',
      tech_role_ph: 'E.g. Site supervisor',
      aansluiter_info: '<strong>Installer</strong> - who performs the physical connection? Both will receive a confirmation email.',
      aansluiter_copy: 'Same as organisation',
      aansluiter_name: 'Installer name',
      aansluiter_email: 'Installer email',
      aansluiter_email_ph: 'connector@company.com',
      aansluiter_phone: 'Installer phone (optional)',
      aansluiter_company: 'Installer company (optional)',
      capacity: 'Max. current (A)',
      capacity_ph: 'Taken from the point if left empty',
      connector: 'Connection type',
      connector_ph: 'Choose a type…',
      connector_unknown: 'Unknown',
      connection: 'Connection (optional)',
      connection_ph: 'E.g. CEE 3x63A',
      cancel: 'Cancel',
      submit: 'Send request →',
      submitting: 'Submitting…',
      submit_failed: 'Submission failed.',
      stations_section: 'Selected stations',
      add_station: '+ Add another station',
      picking_banner: 'Click a station on the map to add it to your reservation.',
      picking_cancel: 'Cancel',
      success_title: 'Thank you for your request!',
      success_body: 'You will receive a confirmation with instructions about the next steps.',
      done: 'Close',
      whats_next: 'What happens next?',
      // Charging-station-only questions (shown when the picked point is a charging station).
      charging_section: 'Additional charging-station details',
      charging_card_q: 'I also want to apply for a construction charging card',
      adapter_q: 'I need an adapter to connect to the charging station',
      adapter_info: 'More information about the adapter',
      adapter_doc_url: '/assets/flyers/adapter-brochure-en.pdf',
      fenced_q: 'The charging station is located within the fences and is closed to regular electric vehicles',
      yes: 'Yes',
      no: 'No',
      // Billing / invoicing block (optional, shown for every request).
      finance_section: 'Billing (optional)',
      finance_info: 'Invoice details for this request - leave empty if they match the organisation.',
      finance_copy: 'Same as organisation',
      billing_name: 'Billing name',
      billing_email: 'Billing email',
      billing_address: 'Street and number',
      billing_postcode: 'Postcode',
      billing_city: 'City',
      billing_vat: 'VAT / CoC number',
      billing_reference: 'Reference / PO number',
    },
    polygon: {
      first_vertex:       'Click on the map to place your first vertex.',
      more_needed:        '{count} of min. 3 vertices - place {remaining} more.',
      ready_to_close:     '{count} vertices - click the start point or "Finish" to close.',
      self_intersect:     'Warning: the polygon crosses itself. Submission still works, but the operator may need to clarify the area.',
      pick_valid_dates:   'Please pick a valid start and end date.',
      end_after_start:    'Start date must be on or before end date.',
      request_submitted:  'Request submitted: {id}',
      check_form:         'Please check the form and try again.',
      submit_failed:      'Submission failed.',
      submitting:         'Sending…',
    },
  },
};
